import { SendCheck } from "components/Icons";
import { ModalContext } from "components/ModalContext";
import { useCallback, useContext, useEffect, useState } from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import { SignInFormik } from "./SignInFormik";
import { SignInSent } from "./SignInSent";

export const SignInModal = (props: ModalProps) => {
  const { close } = useContext(ModalContext);
  const [isSent, setIsSent] = useState(false);
  const [email, setEmail] = useState('');
  const onSuccess = useCallback((email) => {
    setEmail(email);
    setIsSent(true);
  }, []);

  useEffect(() => {
    if (!props.show) {
      setIsSent(false);
    }
  }, [props.show]);

  return (
    <Modal
      {...props}
      show
      onHide={close}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="h5 d-flex align-items-center">
          <SendCheck className="me-2" />{' '}로그인
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isSent ? (<SignInSent email={email} />) : (<SignInFormik onSuccess={onSuccess} />)}
      </Modal.Body>
    </Modal>
  )
}
